/* eslint-disable @typescript-eslint/no-explicit-any */
import { NetExtReport } from "@/constants/netEvent";
import { reqPost } from "@/service/clientRequest";
import {
  ConfirmReportReq,
  GetReportContentRsp,
} from "@/types/swagger/extReport";
import { NullReq } from "@/types/swagger/userwealth";

export const postGetReportContent = () => {
  return reqPost<NullReq, GetReportContentRsp>(
    {},
    NetExtReport.mod,
    NetExtReport.GetReportContent,
    true,
  );
};

export const postReportToServerNew = (reportList: any[]) => {
  return reqPost<ConfirmReportReq, any>(
    {
      data: reportList,
    } as ConfirmReportReq,
    NetExtReport.mod,
    NetExtReport.ConfirmReport,
    true,
  );
};
